import { useState, useEffect } from "react";
import FormInput from "../components/FormInput";
import emailjs from "emailjs-com";

export default function Kontakt() {
  useEffect(() => {
    document.title = "Kontakt - Erik Schott";
  }, []);

  const [values, setValues] = useState({
    username: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState(null);

  const inputs = [
    {
      id: 1,
      name: "username",
      type: "text",
      placeholder: "Ihr Name",
      errorMessage:
        "Username should be 3-16 characters and shouldn't include any special character!",
    },
    {
      id: 2,
      name: "email",
      type: "email",
      placeholder: "Ihre E-Mail-Adresse",
      errorMessage: "It should be a valid email address!",
    },
    {
      id: 3,
      name: "message",
      type: "text",
      placeholder: "Ihre Nachricht",
      errorMessage: "Message should not be empty!",
    },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prüfung: Ob alle Felder ausgefüllt wurden
    if (!values.username.trim() || !values.email.trim() || !values.message.trim()) {
      setStatus({ type: "error", message: "Füllen Sie bitte alle Felder aus." });
      return;
    }

    try {
      // EmailJS API
      const res = await emailjs.send(
        "service_ujwmo7e",  // EmailJS service ID
        "template_mhybufc",  // EmailJS template ID
        {
          from_name: values.username,
          from_email: values.email,
          message: values.message,
        },
        "WENKfpITnhWypWZwW"  // EmailJS public(!) API key
      );

      if (res.status === 200) {
        setStatus({ type: "success", message: "Nachricht erfolgreich versandt!" });
        setValues({ username: "", email: "", message: "" }); // Formular-Inhalte löschen, wenn erfolgreich versandt
      } else {
        setStatus({ type: "error", message: "Nachricht konnte nicht gesendet werden." });
      }
    } catch (error) {
      setStatus({ type: "error", message: "Beim Senden der Nachricht ist ein Fehler aufgetreten." });
    }
  };

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content-wrapper">
          <div className="content-head">
            <h1 className="h1">Kontakt</h1>
            <h2 className="h4">Hinterlasst mir eine Nachricht!</h2>
          </div>

          <div className="input-wrapper">
          <form onSubmit={handleSubmit}>
              {status && (
                <div className={`status-message ${status.type === "success" ? "text-success" : "text-error"} bodycopy`}>
                  <p className="status-message-text">{status.message}</p>
                  <span
                    className="material-symbols-outlined"
                    style={{
                      fontSize: "calc(1.125rem * 2)", color: status.type === "success" ? "#155724" : "#721c24",
                    }}
                  >
                    {status.type === "success" ? "check_circle" : "error"}
                  </span>
                </div>
              )}
              {inputs.map((input) => (
                <FormInput
                  key={input.id}
                  {...input}
                  value={values[input.name]}
                  onChange={onChange}
                />
              ))}
              <button type="submit" className="button-primary">
                <span className="h4">Absenden</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
